<template>
    <div
        v-if="appParams && appParams.staticTranslations"
        id="itb-term-box"
        v-show="isOpen"
        class="card"
    >
        <nav>
            <button class="itb-mdi-logo" @click="toggleIcon">
                <span class="mdi mdi-close"></span>
            </button>

            <span class="itb-terms-headline">
                {{ appParams.staticTranslations["carts.terms"] }}
            </span>
        </nav>

        <div class="itb-term-body">
            <div>
                <h2>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_001"
                        ]
                    }}</strong>
                </h2>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_002"
                        ]
                    }}
                    <span class="highlight preview_website_name"
                        >epdm-graphics.com</span
                    >!
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_003"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o. </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_004"
                        ]
                    }}
                    <span class="highlight preview_website_url"
                        >https://epdm-graphics.com/</span
                    >.
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_005"
                        ]
                    }}
                    <span class="highlight preview_website_name"
                        >epdm-graphics.com</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_006"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_007"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_008"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_009"
                        ]
                    }}
                    <span class="highlight preview_website_name">
                        epdm-graphics.com </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_010"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o. </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_011"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_012"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_013"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_014"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o.</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_015"
                        ]
                    }}
                    <span class="highlight preview_website_name"
                        >epdm-graphics.com </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_016"
                        ]
                    }}
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_017"
                        ]
                    }}
                    <span class="highlight preview_website_name"
                        >epdm-graphics.com</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_018"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_019"
                        ]
                    }}
                </p>
                <ul>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_020"
                            ]
                        }}
                        <span class="highlight preview_website_name"
                            >epdm-graphics.com</span
                        >
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_021"
                            ]
                        }}
                        <span class="highlight preview_website_name"
                            >epdm-graphics.com</span
                        >
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_022"
                            ]
                        }}
                        <span class="highlight preview_website_name"
                            >epdm-graphics.com</span
                        >
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_023"
                            ]
                        }}
                        <span class="highlight preview_website_name"
                            >epdm-graphics.com</span
                        >
                    </li>
                </ul>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_024"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_025"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o.</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_026"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o. </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_027"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o.</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_028"
                        ]
                    }}
                </p>
                <p>
                    <span class="highlight preview_company_name"
                        >4soft s.r.o.</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_029"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_030"
                        ]
                    }}
                </p>
                <ul>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_031"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_032"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_033"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_034"
                            ]
                        }}
                    </li>
                </ul>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_035"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o.</span
                    >
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_036"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_037"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_038"
                        ]
                    }}
                </p>
                <ul>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_039"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_040"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_041"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_042"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_043"
                            ]
                        }}
                    </li>
                </ul>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_044"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_045"
                        ]
                    }}
                </p>
                <ul>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_046"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_047"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_048"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_049"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_050"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_051"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_052"
                            ]
                        }}
                    </li>
                </ul>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_053"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o. </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_054"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_055"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_056"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o. </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_057"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_058"
                        ]
                    }}
                </p>
                <ul>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_059"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_060"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_061"
                            ]
                        }}
                    </li>
                </ul>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_062"
                        ]
                    }}
                    <span class="highlight preview_company_name"
                        >4soft s.r.o. </span
                    >{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_063"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_064"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_065"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_066"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_067"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_068"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_069"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_070"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_071"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_072"
                        ]
                    }}
                </p>
                <h3>
                    <strong>{{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_073"
                        ]
                    }}</strong>
                </h3>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_074"
                        ]
                    }}
                </p>
                <ul>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_075"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_076"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_077"
                            ]
                        }}
                    </li>
                    <li>
                        {{
                            appParams.staticTranslations[
                                "terms_and_conditions.text_078"
                            ]
                        }}
                    </li>
                </ul>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_079"
                        ]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations[
                            "terms_and_conditions.text_080"
                        ]
                    }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "TermsAndCondition",
    props: {
        visible: Boolean,
    },

    computed: {
        isOpen: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },

        ...mapGetters({
            appParams: "getAppParams",
        }),
    },

    data() {
        return {};
    },

    methods: {
        toggleIcon() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
